// extracted by mini-css-extract-plugin
module.exports = {"responsesDetailItemHr":"ResponsesDetailHr_responsesDetailItemHr__2_9YF"};